import React, { useEffect } from 'react';
import {
  useFormEvents,
  ErrorDisplay,
  Loading,
  withCurrentUser,
  ResponsiveContainer,
} from '@lib/common';
import { accountService, AccountForms, FormStatus } from '@lib/state';
import { Typography } from '@material-ui/core';
import { UserInfo } from '@lib/state/session';
import { VerifyPhoneNumberComponent } from '@lib/common';

const VerifyPhoneNumberPageComponent: React.FC<{ user: UserInfo }> = ({ user }) => {
  const [result] = useFormEvents(AccountForms.SendPhoneNumberVerificationCode);

  useEffect(() => {
    accountService.sendVerifyPhoneNumberCode(user.phone_number);
  }, [user.phone_number]);

  const onResendToken = () => {
    accountService.sendVerifyPhoneNumberCode(user.phone_number);
  };

  const sendVerificationToken = () => {
    switch (result.status) {
      case FormStatus.Success: {
        return (
          <VerifyPhoneNumberComponent
            phone={user.phone_number}
            sendTokenResult={result.status}
            resendToken={onResendToken}
          />
        );
      }
      case FormStatus.Error: {
        return (
          <ErrorDisplay error={result.error}>
            <Typography align="center">
              There was error sending a verification token to your registered phone number.
            </Typography>
          </ErrorDisplay>
        );
      }
      default:
        return <Loading />;
    }
  };
  return <ResponsiveContainer>{sendVerificationToken()}</ResponsiveContainer>;
};
export const VerifyPhoneNumberPage = withCurrentUser(VerifyPhoneNumberPageComponent);
